const calcAmount = (rp, a, b) => {
    // ** this is the natural log
 let freshAmount = a * Math.log(rp) + b   
 return freshAmount.toFixed(2)
}

export default calcAmount